import { graphql } from '@shared/types/customer'

export const customerWishlistQuery = graphql(`
  query CustomerWishlists {
    customer {
      metafield(namespace: "custom", key: "wishlists") {
        id
        key
        value
        type
      }
    }
  }
`)

export const setWishlistQuery = graphql(`
  mutation SetCustomerWishlistsMetafield(
    $customerId: ID!
    $wishlists: String!
  ) {
    metafieldsSet(
      metafields: [
        {
          ownerId: $customerId
          namespace: "custom"
          key: "wishlists"
          type: "json"
          value: $wishlists
        }
      ]
    ) {
      wishlists: metafields {
        id
        key
        value
        type
      }
      userErrors {
        field
        message
      }
    }
  }
`)
